<h1>Back Office !</h1>

<ul class="list-group">
    <li class="list-group-item">
        <a routerLink="/blog/new" class="link-dark">Créer un nouvel article de blog</a>
    </li>
    <li class="list-group-item">
        <a routerLink="/vos-avis" class="link-dark">Gérer les avis</a>
    </li>
</ul>

<button (click)="onDeconection()" class="btn btn-danger ms-3 mt-3 mb-3">Se déconnecter</button>
